import packageJson from '../../../package.json'

const BrandTitle = () => {
    return (
        <div className="flex items-center mb-4">
            <img src="/storyverse.svg" alt="Storyverse Logo" className="h-12 w-12 w-auto" />
            <span className="text-2xl font-bold text-primary ml-2">Storyverse</span>
            <span className="text-sm text-gray-500 ml-2">
                <sup>v{packageJson.version}</sup>
            </span>
        </div>
    )
}

export default BrandTitle
